import { GREY } from '@/constants/color';
import { InfoOutlined } from '@mui/icons-material';
import { Tooltip } from '@mui/material';

const StepByStepTooltip = () => (
  <Tooltip
    title={
      <div className='text-left'>
        <strong>Step by Step Process:</strong>
        <ol className='list-decimal ml-4 mt-2 space-y-1'>
          <li>Please download the template by clicking the "Template" button.</li>
          <li>
            In the downloaded template, enter your list of addresses in column A, and radius in miles in column B.
          </li>
          <li>Enter any additional parameters you'd like to forecast, such as audiences, products, etc.</li>
          <li>Save the file and click the "Upload CSV" button to upload it back into the system.</li>
          <li>
            You will receive a file to your email with the output showing available impressions as soon as processing is
            complete.
          </li>
        </ol>
      </div>
    }
    placement='top'
    arrow
  >
    <InfoOutlined sx={{ width: '16px', height: '16px', color: GREY, displayPrint: 'none' }} />
  </Tooltip>
);

export default StepByStepTooltip;
